import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Auth0Service } from 'src/app/shared/services/auth0.service';

@Injectable()
export class AccountCreationGuardService {
  constructor(private router: Router, private auth0Service: Auth0Service) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    var secureLinkId = route.params.secureLinkId;
    var obs = this.auth0Service
      .getBySecureLinkId(secureLinkId)
      .pipe(map((data) => (data?.hasExpired ? false : true)));

    obs.subscribe((canNavigate) => {
      if (canNavigate) {
        return;
      }
      this.router.navigate(['/create-account/closed']);
    });

    return obs;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
